import React, { useCallback, memo } from 'react';
import PropTypes from 'prop-types';

import styles from './styles/FormInput.module.css';

const FormInput = ({
    type = 'text',
    value,
    onChange,
    placeholder,
    required = false,
    disabled = false,
    rows = 3,
    className = '',
    id,
    name,
    autoComplete,
    maxLength,
    minLength,
    min,
    max,
    step,
    ...props
}) => {
    const handleChange = useCallback(e => {
        if (onChange) {
            onChange(e.target.value, e);
        }
    }, [onChange]);

    const commonProps = {
        id,
        name,
        value: value || '',
        onChange: handleChange,
        placeholder,
        required,
        disabled,
        autoComplete,
        maxLength,
        minLength,
        className: `${styles.input} ${className}`.trim(),
        ...props
    };

    if (type === 'textarea') {
        return (
            <textarea
                {...commonProps}
                rows={rows}
                className={`${styles.textarea} ${className}`.trim()}
            />
        );
    }

    if (type === 'number') {
        return (
            <input
                {...commonProps}
                type="number"
                min={min}
                max={max}
                step={step}
            />
        );
    }

    return (
        <input
            {...commonProps}
            type={type}
        />
    );
};

FormInput.propTypes = {
    type: PropTypes.oneOf(['text', 'email', 'password', 'number', 'url', 'tel', 'textarea']),
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    onChange: PropTypes.func,
    placeholder: PropTypes.string,
    required: PropTypes.bool,
    disabled: PropTypes.bool,
    rows: PropTypes.number,
    className: PropTypes.string,
    id: PropTypes.string,
    name: PropTypes.string,
    autoComplete: PropTypes.string,
    maxLength: PropTypes.number,
    minLength: PropTypes.number,
    min: PropTypes.number,
    max: PropTypes.number,
    step: PropTypes.number,
};

export default memo(FormInput);
